import { render, staticRenderFns } from "./generalTable.vue?vue&type=template&id=515505cb&scoped=true&"
import script from "./generalTable.vue?vue&type=script&lang=js&"
export * from "./generalTable.vue?vue&type=script&lang=js&"
import style0 from "./generalTable.vue?vue&type=style&index=0&id=515505cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515505cb",
  null
  
)

export default component.exports